import { Container, Provider, Subscribe } from 'unstated';

export { Provider, Subscribe };

export default class FilterContainer extends Container {

    /**
     * Initializes the container's `state`.
     *
     * @class
     *
     * @param {Object} props - The data returned from a search response.
     */
    constructor( props = {} ) {

        super( props );

        // console.log( 'what the what' );

        this.state = { currentFilterOptions: {} };

    }

    /**
     * Update the state with the selected filter option.
     *
     * @param {String} filterName - The name of the current filter.
     * @param {Object} selectedOption - The selected filter object.
     */
    updateStatefromData = ( filterName, selectedOption ) => {

        const filterStateObj = {};

        filterStateObj[ filterName ] = selectedOption;

        this.setState( ( state ) => {

            const newFilterOptions = Object.assign( state.currentFilterOptions, filterStateObj );

            return { currentFilterOptions: newFilterOptions };

        } );

    };

    /**
     * Update the state with all of the selected filters options.
     *
     * @param {Object} selectedOptions - All of the selected filters.
     */
    updateAllStatefromData = ( selectedOptions ) => {

        this.setState( ( state ) => {

            return { currentFilterOptions: selectedOptions };

        } );

    };

    updateStateForQuery = ( selectedFilters ) => {

        this.setState( ( state ) => {

            // const newFilterOptions = Object.assign( state.currentFilterOptions, filterStateObj );

            return { selectedFilters };

        } );

    };

}

